import React, { useContext, useEffect, useState } from "react";
import EncodingService from "../api/encoding/EncodingService";
import encodingService from "../api/encoding/EncodingService";
import { Button, Search, Select, Table, TextBox, ThemeProvider } from "@veneer/core";
import brand from "@veneer/hp-brand";
import { EmailValidator } from "commons-validator-js";
import { showToast } from "../components/Toast";
import Header from "../Header";
import NavbarISO from "../NavbarISO";
import Navigation from "../Navigation";
import { Modal } from "react-bootstrap";
import Footer from "../Footer";
import { AuthContext } from "../auth/AuthContext";
import { filterSort, getEditRoles } from "../common";
import Notices from "../components/Notices";
import { AUTHENTICATED, removeLocalStorageItem } from "../utils/storage-utils";

const StyledTextBox = ({ helperText, error, children, ...props }) => {
    const containerStyle = {
        position: 'relative'
    };
    const helperTextStyle = {
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        paddingTop: '12px ',
        marginTop: '12px',
        fontSize: '14px',
        backgroundColor: '#ffffff',
        border: 'none',
        borderRadius: '4px',
        color: '#000000',
        lineHeight: '1.5',
        display: helperText ? 'flex' : 'none',
        alignItems: 'center',
        gap: '5px',
        zIndex: 10
    };
    const RedCircleIcon = () => (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            style={{ minWidth: '18px' }}
        >
            <circle
                cx="12"
                cy="12"
                r="10.5"
                fill="#CC2C00"
                stroke="#CC2C00"
                strokeWidth="1"
            />
            <line
                x1="6"
                y1="12"
                x2="18"
                y2="12"
                stroke="white"
                strokeWidth="1.4"
                strokeLinecap="round"
            />
        </svg>
    );
    return (
        <div style={containerStyle}>
            <TextBox {...props} helperText="" style={{
                ...props.style,
                border: helperText ? '1px solid #CC2C00' : props.style?.border,
            }} />
            <div style={helperTextStyle}>
                {helperText && (
                    <>
                        <RedCircleIcon />
                        <span>{helperText}</span>
                    </>
                )}
            </div>
        </div>
    );
};

const Operator = (props) => {

    const [addName] = useState('')
    const [addEmail, setAddEmail] = useState('')
    const [, setRole] = useState('')
    const [selectedOption, setSelectOption] = useState('')
    const [targetId, setTargetId] = useState(0)
    const [status, setStatus] = useState('')
    const [tableDisplayData, setTableDisplayData] = useState([])
    const [originalData, setOriginalData] = useState([])
    const [business, setBusiness] = useState('')
    const [addUserResult, setAddUserResult] = useState('')
    const [addUserResultColor, setAddUserResultColor] = useState('')
    const [, setOptions] = useState([])
    const [isOpenUpdateModal, setIsOpenUpdateModal] = useState(false)
    const [updateModalMsg, setUpdateModalMsg] = useState('')
    const [isOpen, setIsOpen] = useState(false)
    const [isOpenError, setIsOpenError] = useState(false)
    const [idToDelete, setIdToDelete] = useState(-1)
    const [errDesOnDelete, setErrDesOnDelete] = useState('')
    const [mfgLocation, setMfgLocation] = useState('')
    const [mfgLocationStatusMsg, setMfgLocationStatusMsg] = useState('')
    const [mfgLocationColor, setMfgLocationColor] = useState('')
    const [emailToDelete, setEmailToDelete] = useState({})
    const [btnLoading, setBtnLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [loading, setLoading] = useState(false)
    const [filterEmailValue, setFilterEmailValue] = useState('');
    const [emailErrorText, setEmailErrorText] = useState('');
    const [roleErrorText, setRoleErrorText] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [roleError, setRoleError] = useState(false);
    const [userRoles, setUserRoles] = useState([])


    const { uiAccess } = useContext(AuthContext);

    const filterData = filterSort(tableDisplayData, { email: filterEmailValue });

    useEffect(() => {
        getBusiness();
        getUserRoles()
    }, [])

    useEffect(() => {
        getAllUserData();
    }, [userRoles])

    const getUserRoles = () => {
        EncodingService.getRolesByBusiness(props.businessId).then(res => {
            setUserRoles(res.data)
        }, (error) => {
            console.log(error)
        }).catch(() => {
            removeLocalStorageItem(AUTHENTICATED);
            window.location.href = "/supplyencodingsvc/?state=Error";
        });
    }

    const getAllUserData = () => {
        setLoading(true)
        EncodingService.getAllUser().then(res => {
            let dbTableData = [];
            let dbOriginalData = [];
            let busName = null;
            res?.data?.forEach((item) => {
                busName = item.businessName;
                let roleStatus;
                if (item.role === "Administrator") {
                    roleStatus = "Full access for the user's business";
                } else if (item.role === "Operator") {
                    roleStatus = "Access to the download page and encoding API for the user's business";
                } else if (item.role === "Supervisor") {
                    roleStatus = "Access to the download page, encoding API, and monthly summary for the user's business";
                } else if (item.role === "Viewer") {
                    roleStatus = "View only access to Reman account information";
                } else if (item.role === "Sales Rep") {
                    roleStatus = "Access Adds/changes Remans accounts, updates supply cap, and makes adjustments. Cannot change price";
                } else if (item.role === "Pricing Admin") {
                    roleStatus = "Can enable supplies per business and update price";
                } else if (item.role === "SPS Administrator") {
                    roleStatus = "Manages Reman accounts, users, target supplies, and SW Catalog";
                } else if (item.role === "Supplies Business Owner") {
                    roleStatus = "Owns product catalog. Able to configure SKUs";
                } else {
                    roleStatus = "NA";
                }
                let obj = {
                    email: item.email,
                    name: item.fullName,
                    businessId: item.businessName,
                    proxy_role: item.role,
                    role: <select disabled={!item['canDelete']} id={'userSelect'} name="role" className="select-role"
                        value={item.role}
                        onChange={(e) => handleRoleChange(e, item)}>
                        {userRoles?.map(({ roleName, id }) => <option
                            key={id} data-key={id} value={roleName}>{roleName}</option>)}
                    </select>,
                    delete: <Button
                        disabled={!item['canDelete']}
                        id={"delete" + item.id}
                        small={true}
                        onClick={(e) => {
                            handleDelete(e, item.email);
                        }}
                        appearance="secondary"
                    >
                        Delete
                    </Button>,
                    selectedOption: 'None',
                    counter: "delete" + item.id,
                    id: item.id,
                    status: roleStatus
                }
                dbTableData.push(obj)
                dbOriginalData.push(obj)
            });
            const name = busName !== 'SPTS' && busName !== 'HP' ? 'Other' : busName;
            setOriginalData(dbOriginalData)
            setTableDisplayData(dbTableData)
            setBusiness(busName)
            setOptions(getEditRoles(name, props.role))
            setLoading(false)
        }).catch(() => {
            removeLocalStorageItem(AUTHENTICATED);
            window.location.href = "/supplyencodingsvc/?state=Error";
        })
    }

    const getBusiness = () => {
        EncodingService.getBusiness(props.businessId).then(res => {
            setMfgLocation(res?.data?.mfgLocation)

        }, (error) => {
            setMfgLocationColor(brand.color.red)
            setMfgLocationStatusMsg(error.response.data.message)
        }).catch(() => {
            removeLocalStorageItem(AUTHENTICATED);
            window.location.href = "/supplyencodingsvc/?state=Error";
        });
    }

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    const handlePageSizeChange = (event, option) => {
        setPageSize(option.value)
    };

    const handleEmailFilter = (value) => {
        setFilterEmailValue(value);
        setCurrentPage(1); 
    };

    const handleRoleChange = (e, { id, email, businessName }) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        let roleId = selectedOption.getAttribute('data-key')
        console.log(selectedOption.getAttribute('data-key'))
        let payload = {
            id: id,
            roleId: roleId,
            email: email,
            business_name: businessName,
            roles: e.target.value,
        }
        encodingService.updateUser(payload).then(() => {
            getAllUserData()
            showToast(<p className={'apiResponseText'}>user <span><b>{email}</b></span> is updated successfully.
            </p>, 'success')
        }, (error) => {
            showToast("Error : " + error.response.data.message, 'error')
        })
    }

    const handleChange = ({ value, id }) => {
        if (value === "Administrator") {
            setStatus("Full access for the user's business")
        }
        if (value === "Supervisor") {
            setStatus("Can edit accounts and cap/pricing")
        }
        if (value === "Operator") {
            setStatus("Access to the download page and encoding API for the user's business")
        }
        setSelectOption(value)
        setTargetId(id)
        setRoleError(false)
        setRoleErrorText('')

    }

    const validateEmail = (email) => {
        const validator = new EmailValidator()
        return validator.isValid(email)
    }

    const saveOperatorData = () => {
        let returnValue = true;
        setAddUserResult('')
        const addEmailRegex = /^[0-9a-zA-Z]+(([@._\-+])?[0-9a-zA-Z])+?$/g;
        if (addEmail.trim() === '') {
            setEmailErrorText("Please enter email address.")
            setEmailError(true)
            return false;
        }
        if (!validateEmail(addEmail) || addEmail.match(addEmailRegex) === null) {
            setEmailErrorText("Enter a valid email address.")
            setEmailError(true)
            return false;
        }
        if (selectedOption === '' || selectedOption === 'Select role') {
            setRoleErrorText("Select a role.")
            setRoleError(true)
            setAddUserResultColor(brand.color.red)
            return false;
        }
        if (!validateEmail(addEmail))
            return false;
        tableDisplayData.forEach((item) => {
            if (item.email === addEmail) {
                setEmailErrorText("Duplicate email.")
                setEmailError(true)
                returnValue = false;
            }
        });
        if (returnValue) {
            setAddUserResult('')
            let user = {
                email: addEmail,
                business_name: business,
                roles: selectedOption,
                status: status,
                roleId: targetId
            }
            EncodingService.addNewUser(user).then(res => {
                let roleStatus;
                if (selectedOption === "Administrator") {
                    roleStatus = "Full access for the user's business";
                } else if (selectedOption === "Operator") {
                    roleStatus = "Access to the download page and encoding API for the user's business";
                } else if (selectedOption === "Supervisor") {
                    roleStatus = "Access to the download page, encoding API, and monthly summary for the user's business";
                } else if (selectedOption === "Viewer") {
                    roleStatus = "View only access to Reman account information";
                } else if (selectedOption === "Sales Rep") {
                    roleStatus = "Access Adds/changes Remans accounts, updates supply cap, and makes adjustments. Cannot change price";
                } else if (selectedOption === "Pricing Admin") {
                    roleStatus = "Can enable supplies per business and update price";
                } else if (selectedOption === "SPS Administrator") {
                    roleStatus = "Manages Reman accounts, users, target supplies, and SW Catalog";
                } else if (selectedOption === "Supplies Business Owner") {
                    roleStatus = "Owns product catalog. Able to configure SKUs";
                } else {
                    roleStatus = "NA";
                }
                let userList = {
                    name: addName,
                    email: addEmail,
                    proxy_role: selectedOption,
                    role: <select disabled={!res.data['canDelete']} id={"select" + res.data.id} name="role"
                        className=" select-role"
                        value={selectedOption}
                        onChange={(e) => handleRoleChange(e, res.data)}>
                        {userRoles?.map(({ roleName, id }) => <option
                            key={id} data-key={id} value={roleName}>{roleName}</option>)}
                    </select>,
                    delete: <Button
                        disabled={!res.data['canDelete']}
                        id={"delete" + res.data.id}
                        small={true}
                        appearance="secondary"
                        className="button-p"
                        onClick={(e) => {
                            handleDelete(e, addEmail);
                        }}
                    >
                        Delete
                    </Button>,
                    selectedOption: 'None',
                    status: roleStatus,
                    id: res.data.id
                };
                let tableAccount = tableDisplayData;
                let tableAccountOriginal = originalData;
                tableAccount.push(userList)
                tableAccountOriginal.push(userList);
                setTableDisplayData(tableAccount);
                setOriginalData(tableAccountOriginal)
                showToast(<p className={'apiResponseText'}>user <span><b>{user.email}</b></span> is added successfully.
                </p>, 'success')
                setAddEmail('')
                setRole('Select role')
                setAddUserResultColor(brand.color.hpBlue100)
            }, (error) => {
                setAddUserResult("Error : " + error.response.data.message)
                setAddUserResultColor(brand.color.red)
            });
        }
    }

    const deleteUser = () => {

        setBtnLoading(true);

        // Validate ID first
        const numericId = Number(idToDelete);

        if (!idToDelete || numericId <= 0 || isNaN(numericId)) {
            setIsOpenError(true);
            setIdToDelete(-1);
            setErrDesOnDelete(`Invalid user ID: ${idToDelete}. Cannot delete user.`);
            setBtnLoading(false);
            return;
        }

        if (numericId === 1) {

            setIsOpenError(true);
            setIdToDelete(-1);
            setErrDesOnDelete('Cannot delete admin user');
            setBtnLoading(false);
            return;
        }


        // Use numericId instead of idToDelete to avoid state timing issues
        EncodingService.deleteUser(numericId).then(() => {
            let newList = [];
            tableDisplayData.forEach((item) => {
                if (item.id === numericId) {
                    showToast(<p>user <span><b>{item.email}</b></span> is deleted successfully.</p>, 'success');
                } else {
                    newList.push(item);
                }
            });

            setIdToDelete(-1);
            setTableDisplayData(newList);
            setIsOpen(false);
            setBtnLoading(false);

            // Fix pagination calculation - use newList instead of tableDisplayData
            let page_data = newList.slice((currentPage - 1) * pageSize,
                (currentPage - 1) * pageSize + pageSize);

            if (page_data.length === 0 && currentPage > 1) {
                setCurrentPage(currentPage - 1);
            }
        }, (error) => {
            setIdToDelete(-1);
            setIsOpenError(true);
            setErrDesOnDelete(error.response?.data?.message || 'Delete failed');
            setBtnLoading(false);
            setIsOpen(false);
        });
    }

    const handleDelete = (index, email) => {

        // Use currentTarget instead of target to get the actual button
        const buttonElement = index.currentTarget;
        const buttonId = buttonElement.id;

        if (!buttonId || !buttonId.startsWith('delete')) {
            setIsOpenError(true);
            setErrDesOnDelete(`Invalid button ID: ${buttonId}. Cannot delete user.`);
            return;
        }

        const emailID = buttonId.substring(6); // Remove 'delete' prefix
        const userId = Number(emailID);


        // Validate the ID before setting it
        if (!userId || userId <= 0 || isNaN(userId)) {
            setIsOpenError(true);
            setErrDesOnDelete(`Invalid user ID: ${userId}. Cannot delete user.`);
            return;
        }

        setIsOpen(true);
        setIdToDelete(userId);
        setEmailToDelete({ email: email });
    }
    const hideUpdateModal = () => {
        setIsOpenUpdateModal(false)
        setUpdateModalMsg('')
    }

    const hideModal = () => {
        setIsOpen(false);
        setIdToDelete(-1); // Reset the ID when closing modal
    };

    const hideModalError = () => {
        setIsOpenError(false);
        setIdToDelete(-1); // Reset the ID when closing error modal
    };

    const addMFGLocation = () => {
        const manufacturingCityRegex = "^[A-Z|a-z]+([-_,.] *| )?([A-Za-z0-9]+([-_,.] *| )?)*[A-Za-z0-9]$"
        if ((mfgLocation.length > 0) && mfgLocation.match(manufacturingCityRegex)) {
            let business = {
                id: props.businessId,
                mfgLocation: mfgLocation
            };
            EncodingService.updateBusinessAccount(business).then(() => {
                setMfgLocationColor('#027aae')
                showToast('Manufacturing City Saved Successfully', 'success')
                setMfgLocationStatusMsg('')
            }, () => {
                setMfgLocationColor(brand.color.red)
                setMfgLocationStatusMsg('Error adding city. Please try again later.')
            });
        } else {
            if (mfgLocation.length < 0 || mfgLocation === '') {
                setMfgLocationColor(brand.color.red)
                setMfgLocationStatusMsg('Please enter Manufacturing city')
            } else if (mfgLocation.match(manufacturingCityRegex) === null) {
                setMfgLocationColor(brand.color.red)
                setMfgLocationStatusMsg('Invalid entry. Please use text only.')
                setMfgLocation('')
            }
        }
        // setMfgLocation('')
    }

    return (
        <div>
            <Header />
            {uiAccess?.navbarISO && <NavbarISO role={props.role} />}
            {uiAccess?.navigation && <Navigation role={props.role} />}
            <Notices />
            <div className="tableWrapper">
                <div className="row justify-content-start">
                    <div id="operator-section-1" className="add-email-user">
                        <h5 className="subtitle-large p-l-15"> Add users:</h5>
                        <div className="row p-l-15">
                            <div className="col-md-5">
                                <div className="details" id="emailOperator">EMAIL</div>
                                <ThemeProvider mode="light" shape="round" density="high">
                                    <StyledTextBox
                                        density="high"
                                        value={addEmail}
                                        onChange={(addEmail) => {
                                            setAddEmail(addEmail)
                                            setEmailError(false)
                                            setEmailErrorText('')
                                        }}
                                        required
                                        id="required-text-box"
                                        className="text-l input-text"
                                        placeholder=""
                                        maxLength={30}
                                        helperText={emailErrorText}
                                        error={emailError}
                                        style={{ height: '2rem' }}
                                    />
                                </ThemeProvider>
                                <div className="col-md-2">
                                    <span id="reqTxtName" className="reqError req-error"></span>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="details m-t-30">ROLE</div>
                                <ThemeProvider mode="light" shape="round" density="high">
                                    <Select
                                        id={"role"}
                                        name="role"
                                        clearIcon={false}
                                        value={[selectedOption]}
                                        placeholder={'Select role'}
                                        onChange={(e) => handleChange(e)}
                                        options={userRoles ? userRoles.map(({ roleName, id }) => {
                                            return {
                                                value: roleName,
                                                label: roleName,
                                                id: id
                                            }
                                        }) : []}
                                        error={roleError}
                                        helperText={roleErrorText}
                                    />
                                </ThemeProvider>
                                <div className="col-md-2">
                                    <span id="reqTxtName" className="reqError req-error"></span>
                                </div>
                            </div>
                            <div className="col-md-2 m-t-a">
                                <Button appearance="secondary" className="button-p" id='userAddButton' small={true}
                                    onClick={saveOperatorData}>
                                    Add
                                </Button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                {
                                    (addUserResult === "Duplicate email in another business")
                                        ? <span style={{ color: addUserResultColor }}
                                            className="useradded p-l-15">Failed to add user due to internal error. Please report this on <a
                                                href={"https://spssupport.ext.hp.com/"}>HP SPTS Support Website.</a></span>
                                        : <span style={{ color: addUserResultColor }}
                                            className="useradded p-l-15">{addUserResult} </span>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-md-11">
                        <br></br>
                        <h5 className="subtitle-large">Who has access:</h5>
                        <div className="gray-line p-b-35">
                            <Table
                                showFilters={true}
                                columnResize={false}
                                loading={loading}
                                id={'userTable'}
                                columns={[
                                    {
                                        id: 'email',
                                        label: 'Email',
                                        filter: (
                                            <Search
                                                label="Search"
                                                className={'table-filter-email'}
                                                placeholder="Placeholder"
                                                id="table-filter-email"
                                                value={filterEmailValue}
                                                onClear={() => setFilterEmailValue('')}
                                                onChange={(value) => handleEmailFilter(value)}
                                            />
                                        )
                                    },
                                    {
                                        id: 'name',
                                        label: 'FullName'
                                    },
                                    {
                                        id: 'role',
                                        label: 'Role',
                                        sortable: false
                                    },
                                    {
                                        id: 'delete',
                                        label: ''
                                    },
                                    {
                                        id: 'status',
                                        label: ''
                                    }
                                ]}
                                data={tableDisplayData ? filterData.slice((currentPage - 1) * pageSize,
                                    (currentPage - 1) * pageSize + pageSize) : null}
                                pagination={{
                                    currentPage: currentPage,
                                    pageSizeOptions: filterData.length <= 2 ? [{ value: filterData.length }] :
                                        filterData.length < 5 ? [{ value: 2 }, { value: filterData.length }] :
                                            filterData.length <= 8 ? [{ value: 2 }, { value: 4 }, { value: filterData.length }] :
                                                filterData.length <= 9 ? [{ value: 2 }, { value: 4 }, { value: 8 }, { value: filterData.length }] :
                                                    filterData.length <= 10 ? [{ value: 2 }, { value: 4 }, { value: 8 }, { value: filterData.length }] : [{ value: 2 }, { value: 4 }, { value: 8 }, { value: 10 }, { value: filterData.length }],
                                    onPageChange: handlePageChange,
                                    onPageSizeChange: handlePageSizeChange,
                                    totalItems: filterData.length,
                                    pageSize: pageSize
                                }}
                                loadingDataLength={pageSize}
                            />
                        </div>
                    </div>

                </div>
                <div className="p-50">
                    <h5 className="subtitle-large p-b"> Manufacturing city:</h5>

                    <div className="row ">
                        <div className="col-md-7 p-b">
                            <ThemeProvider mode="light" shape="round" density="high">
                                <TextBox
                                    id="locationOperator"
                                    className=""
                                    value={mfgLocation}
                                    onChange={(mfgLocation) => setMfgLocation(mfgLocation)}
                                    placeholder="Manufacturing city" />
                            </ThemeProvider>
                            <span
                                style={{ color: mfgLocationColor }}><strong>{mfgLocationStatusMsg}</strong></span>
                        </div>
                        <div className="col-md-5">
                            <Button small={true} className="button-p" id={"saveMFGLocation"}
                                onClick={addMFGLocation} type="submit">Save</Button>
                        </div>

                        <div className="col-md-12">
                            <div className="support p-60 f-w">Visit <a href="https://spssupport.ext.hp.com/"
                                rel="noopener noreferrer" target="_blank">HP SPTS
                                Support Center</a> for customer support and troubleshooting.
                            </div>
                        </div>
                    </div>
                </div>
                <br></br>
                <br></br>

            </div>

            <Modal show={isOpen} onHide={hideModal} centered>
                <Modal.Body>
                    <div className="modal-body">
                        <p className="f-14">Are you sure you want to delete <span><b>{emailToDelete.email}</b></span>?</p>
                    </div>
                </Modal.Body>

                <div className="modal-footer justify-content-md-center b-t-0">
                    <ThemeProvider mode="light" shape="round" density="high">
                        <Button id="reportErrorCloseBtn" small={true} data-dismiss="modal" appearance="secondary"
                            className="spsaccount m-r-21"
                            onClick={hideModal}>Cancel</Button>
                    </ThemeProvider>
                    <ThemeProvider mode="light" shape="round" density="high">
                        <Button loading={btnLoading} id="reportErrorCloseBtnDel " small={true}
                            className="button-p m-r-20" data-dismiss="modal" onClick={deleteUser}>OK</Button>
                    </ThemeProvider>
                </div>
            </Modal>
            <Modal show={isOpenError} onHide={hideModalError}>
                <Modal.Body>
                    <div className="modal-body justify-content-md-center">
                        <p className="f-14">{errDesOnDelete}</p>
                    </div>
                </Modal.Body>
                <div className="modal-footer justify-content-md-center b-t-0">
                    <ThemeProvider mode="light" shape="round" density="high">
                        <Button id="reportErrorCloseBtn" small={true} data-dismiss="modal" appearance="secondary"
                            className="spsaccount m-r-21" onClick={hideModalError}>Ok</Button>
                    </ThemeProvider>
                </div>
            </Modal>
            <Modal show={isOpenUpdateModal} onHide={hideUpdateModal}>
                <Modal.Body>
                    <div className="modal-body justify-content-md-center">
                        <p className="f-14">{updateModalMsg}</p>
                    </div>
                </Modal.Body>
                <div className="modal-footer justify-content-md-center b-t-0">
                    <ThemeProvider mode="light" shape="round" density="high">
                        <Button
                            id="reportErrorCloseBtnOk"
                            small={true}
                            data-dismiss="modal"
                            appearance="secondary"
                            className="spsaccount m-r-21"
                            onClick={hideUpdateModal}
                        >
                            OK
                        </Button>
                    </ThemeProvider>
                </div>
            </Modal>
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <p>Are you sure you want to delete this user?</p>
                        </div>
                        <div className="modal-footer text-center">
                            <Button small={true} appearance="secondary" className="spsaccount">Cancel</Button>
                            <Button small={true} className="button-p">OK</Button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Operator;